const apiRoot = process.env.REACT_APP_API_ROOT
  ? process.env.REACT_APP_API_ROOT.toString().trim().toLowerCase()
  : "https://bdo-ca1-tp-api-dev-01.azurewebsites.net/api";

export const apiUrls = {
  getMeetingRooms: `${apiRoot}/MeetingRooms`,
  getMeetingRoomDls: `${apiRoot}/MeetingRoomDls`,
  getSipNumbersData: `${apiRoot}/SipNumbers`,
  getSipNumber: `${apiRoot}/SipNumbers/{{id}}`,
  getLocations: `${apiRoot}/Locations`,
  getLocationsUnPooled: `${apiRoot}/Locations/UnPooled`,
  getOrchestratorErrorsData: `${apiRoot}/OrchestratorErrors`,
  getPools: `${apiRoot}/Pools`,
  getPoolsData: `${apiRoot}/Pools/Data`,
  getPoolsId: `${apiRoot}/Pools/{{id}}`,
  getSipAssignmentStatuses: `${apiRoot}/SipAssignmentStatuses`,
  getSipStatuses: `${apiRoot}/SipStatuses`,
  getSipMeetingRoomAssignments: `${apiRoot}/SipMeetingRoomAssignments/{{id}}`,
  getSipNumbersUnPooled: `${apiRoot}/SipNumbers/UnPooled`,
  getSipOtherAssignments: `${apiRoot}/SipOtherAssignments/{{id}}`,
  getSipUserAssignments: `${apiRoot}/SipUserAssignments/{{id}}`,
  getSipTypes: `${apiRoot}/SipTypes`,
  getUsers: `${apiRoot}/Users`,
  getUsersUnassigned: `${apiRoot}/Users/Unassigned`,
  putPoolsId: `${apiRoot}/Pools/{{id}}`,
  putSipNumbers: `${apiRoot}/SipNumbers/{{id}}`,
  putSipNumbersStatus: `${apiRoot}/SipNumbers/Status/{{id}}`,
  putSipMeetingRoomAssignmentsStatus: `${apiRoot}/SipMeetingRoomAssignments/Status/{{id}}`,
  putSipOtherAssignmentsStatus: `${apiRoot}/SipOtherAssignments/Status/{{id}}`,
  putSipUserAssignmentsStatus: `${apiRoot}/SipUserAssignments/Status/{{id}}`,
  postMeetingRooms: `${apiRoot}/MeetingRooms`,
  postMeetingRoomDls: `${apiRoot}/MeetingRoomDls`,
  postPools: `${apiRoot}/Pools`,
  postSipNumbersBulk: `${apiRoot}/SipNumbers/Bulk`,
  postSipNumbersBulkStatusUpdate: `${apiRoot}/SipNumbers/BulkStatusUpdate`,
  postSipMeetingRoomAssignments: `${apiRoot}/SipMeetingRoomAssignments`,
  postSipOtherAssignments: `${apiRoot}/SipOtherAssignments`,
  postSipUserAssignments: `${apiRoot}/SipUserAssignments`,
};
